import http from "./http";

// Admin-level users (role IN super_admin/admin/sales) CRUD.

export const getAdminUsers = async (search = "", page = 1) => {
  const params = new URLSearchParams({ page });
  if (search.trim()) params.set("search", search.trim());
  const res = await http.get(`admin_users?${params.toString()}`);
  return res.data;
};

export const getAdminUserById = async (id) => {
  const res = await http.get(`admin_users?id=${id}`);
  return res.data;
};

export const createAdminUser = async (data) => {
  const res = await http.post("admin_users", data);
  return res.data;
};

export const updateAdminUser = async (id, data) => {
  const res = await http.put("admin_users", { id, ...data });
  return res.data;
};

export const deleteAdminUser = async (id) => {
  const res = await http.delete("admin_users", { data: { id } });
  return res.data;
};
